module.exports = __webpack_public_path__ + "static/media/pixlstrip.309e5613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parentreg/pixlstrip.jpg
// module id = 2860
// module chunks = 0